import {
  COLORS,
  COLORS_BRAND,
  COLORS_CHARTS,
  COLORS_EXTENDED,
} from './theme/tokens';

// Extend Chakra to include Finley colors, fonts, etc
export const colors = {
  // design system colors
  ...COLORS,
  // brand colors
  ...COLORS_BRAND,
  // extended colors: brand colors, background colors, or colors reserved for data visualizations
  ...COLORS_EXTENDED,
  // chart colors
  chart: COLORS_CHARTS,

  // core colors: main UI colors
  /** @deprecated Use colors.gray */
  white: '#FFFFFF',
  /** @deprecated Use colors.gray */
  black: {
    10: '#F6F6F6',
    20: '#ECECEC',
    30: '#E3E3E3',
    40: '#DADADA',
    50: '#C7C7C7',
    60: '#B5B5B5',
    70: '#737373',
    80: '#40413E',
    95: '#0E0E0E',
  },
  /** @deprecated Use colors.red */
  error: 'red.400',
  /** @deprecated Use colors.green */
  success: 'green.400',
  /** @deprecated Use colors.yellow */
  warning: 'orange.400',
  /** @deprecated Use colors.blue */
  info: 'blue.400',
  /** @deprecated Use colors.gray */
  background: {
    50: '#FDFCF9',
    100: '#FAF7F3',
    200: '#F7F4EE',
    300: '#F4F1EA',
    400: '#F9F6F1',
    500: '#E7E3DE',
    600: '#E4E0DA',
    700: '#DCD9D4',
    800: '#D4D0CB',
    900: '#C1BDB8',
  },
  /** @deprecated Use colors.gray */
  tableHeader: '#FAFAFA',
  /** @deprecated Use colors['v2-aurora'] */
  aurora: {
    50: '#E6ECED',
    75: '#97B2B5',
    100: '#4D8F99',
    200: '#2D6469',
    400: '#012E32',
    500: '#012E32',
    800: '#02444A', // brand guide Aurora 75
    900: '#012E32', // brand guide Aurora 90
  },
  /** @deprecated Use light variants from colors.gray or colors['v2-aurora'], depending on your use case */
  millet: {
    50: '#FBFAF9', // brand guide Millet 02
    100: '#F9F6F1', // brand guide Millet 04
    200: '#F3F0ED', // brand guide Millet 06
  },
  /** @deprecated Use colors.gray or colors['v2-aurora'] */
  secondary: {
    100: '#F3D394',
  },
} as const;

/** @deprecated We don't use 8-digit hex codes for alpha values */
export const transparency = {
  100: 'FF',
  95: 'F2',
  90: 'E6',
  85: 'D9',
  80: 'CC',
  75: 'BF',
  70: 'B3',
  65: 'A6',
  60: '99',
  55: '8C',
  50: '80',
  45: '73',
  40: '66',
  35: '59',
  30: '4D',
  25: '40',
  20: '33',
  15: '26',
  10: '1A',
  5: '0D',
  0: '00',
};
